// extracted by mini-css-extract-plugin
module.exports = {"noteTimestamp":"styles-module__noteTimestamp___1hPMR","noteText":"styles-module__noteText___2gcWq"};